import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import RestService from "./../../Restservice";
import Loader from "./../../component/Loader";
import GlobalHelmet from "./../../GlobalHelmet";
import Validate from "./../../component/Authvalidate";
import Breadcrumbs from "./../../component/breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CustomTable from "./../../component/CustomTable";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
});

export default function SectoranalysisData() {
  const params = useParams();
  const ex_sector_id = params.ex_sector_id;
  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);
  const [column, setcolumn] = useState(1);
  const [sector, setsector] = useState([]);
  const [exsectorid, setexsecotrid] = useState(ex_sector_id);

  function refreshPage() {
    var d = new Date();
    var n = d.getTime();
    setcolumn(n);
  }

  useEffect(() => {
    setLoading(true);
    RestService.getsectorAnalysisAllData(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setsector(response.data.getSector);
        if (response.data.status === 1) {
          setglobaldata(response.data.response);
        }
      },
      mobile,
      web_token,
      exsectorid
    );
  }, [column, mobile, web_token, exsectorid]);

  function selectSector(e, newDate) {
    setexsecotrid(newDate.ex_sector_id);
    var d = new Date();
    var n = d.getTime();
    setcolumn(n);
  }

  return (
    <>
      <Validate />
      <GlobalHelmet />
      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <Breadcrumbs page="Sector Analysis" />
          <div className={classes.root}>
            <div className=" ">
              <div className="row">
                <div className="col-md-12">
                  <div className="tabelcontiner">
                    <div className="row edit-columns">
                      <div className="col-md-7">
                        <h3>
                          <span className="highlighttext">Sector Analysis</span>{" "}
                        </h3>
                      </div>
                      <div className="col-md-3">
                        {sector ? (
                          <Autocomplete
                            autoComplete="off"
                            id="country-select-demo"
                            style={{ width: 300 }}
                            options={sector}
                            classes={{
                              option: classes.option,
                            }}
                            onChange={selectSector}
                            getOptionLabel={(option) => option.sector_name}
                            renderOption={(option) => (
                              <React.Fragment>
                                <span>{option.sector_name}</span>
                              </React.Fragment>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Choose Sector"
                                variant="outlined"
                                autoComplete="off"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "new-password", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-md-2 text-right">
                        <button
                          className="btn btn-success"
                          title="Reload Page"
                          onClick={refreshPage}
                        >
                          <i className="fa fa-refresh"></i>
                        </button>{" "}
                        &nbsp;
                        <Link
                          className="btn btn-success"
                          to="/sector-analysis"
                        >
                          <i className="fa fa-arrow-left"></i>{" "}
                        </Link>
                      </div>
                    </div>
                    {!globaldata.getDetails ? (
                      ""
                    ) : (
                      <>
                        <CustomTable
                          key={column.dataField}
                          columndata={
                            globaldata.setColumn ? globaldata.setColumn : ""
                          }
                          marketdata={
                            globaldata.getDetails ? globaldata.getDetails : ""
                          }
                          redirectlink="/stocks/"
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
